import { create } from 'zustand';

interface NetworkState {
  isOnline: boolean;
  isTabVisible: boolean;
  lastWakeTime: number | null;
  lastOfflineTime: number | null;
  lastBackgroundTime: number | null;
}

interface NetworkActions {
  setOnline: (isOnline: boolean) => void;
  setTabVisible: (isTabVisible: boolean) => void;
  setWakeDetected: () => void;
}

type NetworkStore = NetworkState & NetworkActions;

export const useNetworkStore = create<NetworkStore>((set) => ({
  // State
  isOnline: navigator.onLine,
  isTabVisible: !document.hidden,
  lastWakeTime: null,
  lastOfflineTime: null,
  lastBackgroundTime: null,

  // Actions
  setOnline: (isOnline) =>
    set({
      isOnline,
      ...(isOnline ? {} : { lastOfflineTime: Date.now() }),
    }),

  setTabVisible: (isTabVisible) =>
    set({
      isTabVisible,
      ...(!isTabVisible ? { lastBackgroundTime: Date.now() } : {}),
    }),

  setWakeDetected: () => set({ lastWakeTime: Date.now() }),
}));
